import { render, staticRenderFns } from "./DocumentsCreate.vue?vue&type=template&id=0f0af0da&scoped=true"
import script from "./DocumentsCreate.vue?vue&type=script&lang=js"
export * from "./DocumentsCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCreate.vue?vue&type=style&index=0&id=0f0af0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0af0da",
  null
  
)

export default component.exports